import { render, staticRenderFns } from "./LaunchPad.vue?vue&type=template&id=fa803996&scoped=true"
import script from "./LaunchPad.vue?vue&type=script&lang=js"
export * from "./LaunchPad.vue?vue&type=script&lang=js"
import style0 from "./LaunchPad.vue?vue&type=style&index=0&id=fa803996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa803996",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
